// Centralised base measurements and default styling tokens for the room preview.
export const WALL_DIMENSIONS_CM = {
  width: 200,
  height: 200,
};

export const WALL_HEIGHT_PX = 420;
export const FLOOR_HEIGHT_PX = 92;
export const WALL_TEXTURE_TILE_CM = 30;

export const DEFAULT_WALL_COLOR = '#f6f3ed';
export const DEFAULT_FLOOR_COLOR = '#7e5935';
export const EDITION_ROOM_MEASUREMENTS_CM_BY_SIZE = Object.freeze({
  small: Object.freeze({ matWidth: 3, frameFaceWidth: 2, labelGap: 4 }),
  medium: Object.freeze({ matWidth: 4, frameFaceWidth: 3, labelGap: 6 }),
  large: Object.freeze({ matWidth: 5, frameFaceWidth: 4, labelGap: 8 }),
});
export const FRAME_DEPTH_CM = 2;

export const FRAME_STYLES = {
  black: {
    id: 'black',
    className: 'limited-edition-room-preview__frame--black',
  },
  white: {
    id: 'white',
    className: 'limited-edition-room-preview__frame--white',
  },
};
